import React, { memo } from 'react';
import Spinner from '@atlaskit/spinner';
import { fg } from '@atlassian/jira-feature-gating';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { IconContainer, PaddedFlexContainer } from '../../common/ui/styled.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LoadingSpinner = memo<Record<any, any>>(() => {
	const Component =
		isVisualRefreshEnabled() && fg('redesign-linked-issues-issue-view')
			? IconContainer
			: PaddedFlexContainer;
	return (
		<Component>
			<Spinner size="small" />
		</Component>
	);
});
